export const parseLanguage = (localeString) => {
  return localeString
    ?.split(',')
    .map((item) => item.split(';')[0])
    .map((item) => item.split('-')[0])
    .filter((value, index, self) => self.indexOf(value) === index)
    .shift();
};
